module.exports = __webpack_public_path__ + "static/media/guest.c832ea10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/guest.png
// module id = 2498
// module chunks = 68